import styled from 'styled-components'
import {getCurrentColors} from '../utils/colors'

interface TooltipProps {
    left: string
    top: string
    text: string
}

const COLORS = getCurrentColors() // Importando as cores do tema atual

export const StyledTooltip = styled.span<{top: string; left: string}>`
    visibility: hidden;
    position: absolute;
    z-index: 1000;
    width: max-content;
    font-size: 12px;
    top: ${({top}) => top};
    left: ${({left}) => left};
    padding: 5px 10px !important;
    border-radius: 5px;
    background-color: #012441;
    color: #ffffff;
`
export default function Tooltip({left, top, text}: TooltipProps) {
    return (
        <StyledTooltip top={top} left={left}>
            {text}
        </StyledTooltip>
    )
}
